if(!customElements.get('color-variants')) {
  customElements.define('color-variants', class ColorVariants extends HTMLElement {
    constructor() {
      super();
      this.currentColor = this.querySelector('[data-current-color]');
      this.colors = this.querySelectorAll('[data-color]');
      this.colorGroups = this.querySelectorAll('[data-color-group]');
      this.colorGroupOptions = this.querySelectorAll('[data-color-group-value]');
      this.sectionContainer = document.querySelector('[data-section-type="product"]');
    }

    connectedCallback() {
      this.setEventListeners();
    }

    setEventListeners() {
      this.changeGroup();
      this.changeColor();
    }

    changeGroup() {
      if(this.colorGroups.length === 0) return;
      this.colorGroups.forEach(group => {
        group.addEventListener('click', (event) => this.changeGroupHandler(event));
      })
    }

    changeColor() {
      if(this.colors.length === 0) return;
      this.colors.forEach(color => {
        color.addEventListener('click', (event) => this.changeColorHandler(event));
      })
    }

    changeGroupHandler(event) {
      if(!event) return;
      event.preventDefault();
      const groupHandle = event.target?.dataset?.colorGroup;
      if(!groupHandle || this.colorGroupOptions.length === 0) return;
      this.colorGroups.forEach(element => {
        element.classList.remove('active');
      });
      this.colorGroupOptions.forEach(element => {
        element.classList.remove('active');
      });

      const group = this.querySelector(`[data-color-group-value="${groupHandle}"]`);
      if(!group) return;
      event.target.classList.add('active');
      group.classList.add('active');
    }

    async changeColorHandler(event) {
      if(!event) return;
      event.preventDefault();
      const color = event.currentTarget?.dataset?.color;

      let url = event.currentTarget.href;
      if (url.includes('?')) {
        url = url.spit('?')[0];
      }
      if(!url) return;
      if(url.includes(window.location.pathname)) return;      
      if(!color && !this.currentColor) return;
      this.colors.forEach(element => {
        element.classList.remove('active');
      });
      event.currentTarget.classList.add('active');
      this.currentColor.innerText = color;
      window.location.href = url;
      // Change Page layout without reload
      
      // const response = await fetch(url);
      // const result = await response.text();
      // const HTML = new DOMParser().parseFromString(result, 'text/html');
      // const productHTML = HTML.querySelector('[data-section-type="product"]');
      // if(this.sectionContainer && productHTML) {
      //   this.sectionContainer.innerHTML = productHTML.innerHTML;
      // }
      // setTimeout(()=> {
      //   const data = {
      //     container: this.sectionContainer,
      //     id:  this.sectionContainer.id,
      //     type: this.sectionContainer.dataset.sectionType
      //   }
      //   new InitSlider(data);
      //   new Zoom(data);
      // })
    }
  })
}